export function extractColumnsConfig(response) {
  if (Array.isArray(response)) return response;
  if (response?.columns && Array.isArray(response.columns)) return response.columns;
  if (response?.columns_config && Array.isArray(response.columns_config)) return response.columns_config;
  return null;
}
